module.exports = "<div class=\"order-sizes\">\n\t{{tmpl(sizes) 'co-size-item'}}\n</div>\n<div class=\"status\"></div>"


//////////////////
// WEBPACK FOOTER
// ./modules/packages/create_order/templates/sizes.html
// module id = dM69
// module chunks = 2 3 4 5 6 11